import React from 'react';
import cn from 'clsx';

import Tab from './tab/tab';

import styles from './tabs.scss';

interface TabsProps {
  className?: string;
  isSecondary?: boolean;
}

function Tabs(props: React.PropsWithChildren<TabsProps>) {
  const { children, className = '', isSecondary } = props;

  const childrenArray = React.Children.toArray(children);

  if (!childrenArray?.length) return null;

  return (
    <div
      className={cn(styles['container'], `tabs ${className}`)}
      role="tablist"
    >
      {childrenArray.map(child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement, {
            ...child.props,
            isSecondary: isSecondary
          });
        }
      })}
    </div>
  );
}

export { Tab };
export default Tabs;
